import { CompanySettings, CompanySettingsValues } from "../entities/CompanySettings";
import { SettingsRepository } from "../repositories/SettingsRepository";

/**
 * Saves changes to the Company Details form.
 *
 * Sends only the fields that actually differ from what was loaded. A full-form
 * PUT would work — the server ignores locked fields and treats the rest as a
 * partial update — but sending three changed fields instead of sixteen keeps
 * the audit trail and any future concurrency check meaningful.
 */
export class UpdateCompanySettingsUseCase {
  constructor(private readonly repository: SettingsRepository) {}

  execute(
    original: CompanySettingsValues,
    edited: CompanySettingsValues,
    signal?: AbortSignal
  ): Promise<CompanySettings> {
    return this.repository.updateCompanySettings(this.changedFields(original, edited), signal);
  }

  /** The subset of `edited` whose values differ from `original`. */
  private changedFields(
    original: CompanySettingsValues,
    edited: CompanySettingsValues
  ): Partial<CompanySettingsValues> {
    const changes: Partial<CompanySettingsValues> = {};

    Object.keys(edited).forEach((field) => {
      if (edited[field] !== original[field]) {
        changes[field] = edited[field];
      }
    });

    return changes;
  }
}
